import React from 'react'
import { Navigate } from 'react-router-dom'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'

// Gates the entire /patient-home/* tree.
// 1. Auth check — token + authorities present.
// 2. Role check — user has ROLE_PATIENT.
//
// Profile-selection check (have they picked one of N profiles?) lives inside
// the layout, not here, because the layout itself shows the profile picker.

export default function PatientPortalProtectedRoute({ children }) {
  const token = localStorage.getItem('token')
  const authorities = localStorage.getItem('authorities')

  if (isTokenInvalidOrAbsent(token) || !authorities) {
    logoutHandler()
    return <Navigate to="/login" replace />
  }

  const { isPatient } = getAllRolesInBoolean()
  if (!isPatient) {
    return <Navigate to="/" replace />
  }

  return children
}
